// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
    display: flex;
}

.profile-field-container {
    margin: 1rem;
}

.profile-field > div {
    display: flex;
}

.profile-field label {
    width: 8rem;
}

.profile-field input {
    max-width: 12rem;
}

.profile-container-left {
    flex: 1 1 auto;
}

.profile-container-right {
    flex: 0 1 auto;
}

.profile-account-image {
    padding: 1rem;
}

    .profile-account-image > img {
        padding: 0.5rem;
        background-color: lightgray;
        border-radius: 50%;
    }

.profile-control {
    margin: 0rem 0rem 1rem 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/Account/css/AccountProfile.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;IAEI;QACI,eAAe;QACf,2BAA2B;QAC3B,kBAAkB;IACtB;;AAEJ;IACI,2BAA2B;AAC/B","sourcesContent":[".profile-container {\r\n    display: flex;\r\n}\r\n\r\n.profile-field-container {\r\n    margin: 1rem;\r\n}\r\n\r\n.profile-field > div {\r\n    display: flex;\r\n}\r\n\r\n.profile-field label {\r\n    width: 8rem;\r\n}\r\n\r\n.profile-field input {\r\n    max-width: 12rem;\r\n}\r\n\r\n.profile-container-left {\r\n    flex: 1 1 auto;\r\n}\r\n\r\n.profile-container-right {\r\n    flex: 0 1 auto;\r\n}\r\n\r\n.profile-account-image {\r\n    padding: 1rem;\r\n}\r\n\r\n    .profile-account-image > img {\r\n        padding: 0.5rem;\r\n        background-color: lightgray;\r\n        border-radius: 50%;\r\n    }\r\n\r\n.profile-control {\r\n    margin: 0rem 0rem 1rem 1rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
